/* global navigator, ClipboardItem, OffscreenCanvas */
import {getLogger} from 'loglevel';
import {message} from "antd";

const log = getLogger('useCopy');

export default function useCopy() {

  function copyValue(value) {
    navigator.clipboard.writeText(value).then(
      () => {
        message.success('Copied to the clipboard');
      },
      err => {
        log.error(err);
      }
    );
  }

  const toPNGBlob = async (img) => {
    const canvas = new OffscreenCanvas(img.naturalWidth, img.naturalHeight);
    const ctx = canvas.getContext('2d');
    // This removes transparency. Remove at will.
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0);
    return await canvas.convertToBlob();
  };

  const copyImage = async (imgType, imgRef) => {
    try {
      const pngBlob = await toPNGBlob(imgRef.current);
      navigator.clipboard.write([
        new ClipboardItem({
          'image/png': pngBlob
        })
      ]);
      message.success('Copied to the clipboard');
    } catch (error) {
      console.log(error);
    }
  };

  return { copyValue, copyImage };
}



// WEBPACK FOOTER //
// ./src/hooks/useCopy.js